import {axiosApi,axiosWeb} from "@/js/axios";

const state = {
    user: {},

    subscription: null,
    set_fetching_subscription: false,

    paying_invoices: false,
};

const getters = {
    activeUser: (state) => {
        return state.user;
    },

    /**
     * Check there is subscription attached to a user
     *
     * @param state
     * @returns {boolean}
     */
    hasSubscription(state) {
        if (!state.user ||
            !state.user.hasOwnProperty('stripe_id') ||
            !state.user.stripe_id ||
            !state.user.hasOwnProperty('current_billing_plan' ||
                !state.user.current_billing_plan) ||
            !state.user.hasOwnProperty('stripe_subscription') ||
            !state.user.stripe_subscription) return false;

        return true;
    },

    /**
     * Check if user has any past due invoices / unresolved failed payments
     *
     * @param state
     * @returns {boolean}
     */
    hasPastDueInvoices(state) {
        if (!state.user || !state.user.hasOwnProperty('unresolved_failed_payments') || !state.user.unresolved_failed_payments.length) {
            return false;
        } else {
            return true;
        }
    },

    /**
     * Check if user is currently subscribed
     * Also returns true if scheduled canceled at the end of current billing period
     *
     * @param state
     * @param getters
     * @returns {boolean}
     */
    isSubscribed(state,getters) {
        if (!getters.hasSubscription) return false;
        let ends_at = state.user.stripe_subscription.ends_at;
        if (!ends_at) return true;

        return !!moment(ends_at).isAfter(moment());
    },

    /**
     * Check if the active subscription has been canceled
     *
     * @param state
     * @param getters
     * @returns {boolean}
     */
    isCanceled(state,getters) {
        return !!(getters.hasSubscription && state.user.stripe_subscription.ends_at);
    },

    /**
     * Check if user is subscribed and has any past due invoices attached to the Customer Stripe ID
     *
     * @param state
     * @param getters
     * @returns {boolean}
     */
    isSubscribedPastDueInvoices(state,getters) {
        return !!(getters.isSubscribed && getters.hasPastDueInvoices);
    },

    /**
     * Check if user is eligible to resume canceled subscription
     * CONDITIONS:
     *  - must have active subscription
     *  - subscription is canceled, but before end of period date
     *  - must not have past due invoices, and all failed payments resolved
     * @param state
     * @param getters
     * @returns {boolean}
     */
    canResumeSubscription(state,getters) {
        if (!getters.isSubscribed) return false;
        return !getters.hasPastDueInvoices
                ? moment().isBefore(moment(state.user.stripe_subscription.ends_at))
                : false;
    },
    /**
     * Check if user is eligible to cancel active subscription
     * CONDITIONS:
     *  - must have active subscription
     *  - not already canceled
     *  - must not have past due invoices, and all failed payments resolved
     * @param state
     * @param getters
     * @returns {boolean}
     */
    canCancelSubscription(state,getters) {
        return !!(getters.isSubscribed && !getters.isCanceled && !getters.hasPastDueInvoices);
    },

    /**
     * Check if user is eligible to update subscription
     * CONDITIONS:
     *  - must have active subscription
     *  - must not have past due invoices, and all failed payments resolved
     * @param state
     * @param getters
     * @returns {boolean}
     */
    canUpdateSubscription(state,getters) {
        return !!(getters.isSubscribed && !getters.hasPastDueInvoices);
    },

    resumeSubscriptionDate(state,getters) {
        if (!getters.canResumeSubscription) return false;
        return moment(state.user.stripe_subscription.ends_at).startOf('day').format('DD/MM/YYYY');
    },

    /**
     * End of subscription's current period
     *
     * @param state
     * @returns {string}
     */
    currentSubscriptionPeriodEnd(state) {
        if (!state.subscription || !state.subscription.hasOwnProperty('current_period_end')) return '';
        return moment.unix(state.subscription.current_period_end).format("DD/MM/YYYY");
    },
};

const actions = {
    setUser({commit}, payload) {
        commit('SET_USER', payload.user);
    },

    fetchSubscription({state,commit}, payload) {
        commit('SET_FETCHING_SUBSCRIPTION', true);
        return new Promise((resolve, reject) => {
            axios.get(`/api/v1/subscription-plan`)
                .then(({data}) => {
                    commit('SET_SUBSCRIPTION', data);
                    resolve();
                    commit('SET_FETCHING_SUBSCRIPTION', false);
                })
                .catch(error => {
                    commit('SET_FETCHING_SUBSCRIPTION', false);
                    reject(error);
                })
        });

    },
};

const mutations = {
    SET_USER(state, data) {
        state.user = data;
    },

    SET_SUBSCRIPTION(state,data) {
        state.subscription = data;
    },
    SET_FETCHING_SUBSCRIPTION(state,value) {
        state.set_fetching_subscription = value;
    },
    SET_PAYING_INVOICES(state,value) {
        state.paying_invoices = value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/user.js